import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';
import { InvoiceStatus } from 'models/invoice';

type InvoiceStatusChipProps = {
    status: string; // TODO: Use enum for status...
};
const InvoiceStatusChip: FC<InvoiceStatusChipProps> = ({ status }: InvoiceStatusChipProps) => {
    const { t: translate } = useTranslation(['invoices']);

    const colorMap = {
        [InvoiceStatus.ALL.valueOf()]: '', // Ignore this, just to solve type issues
        [InvoiceStatus.CREATED.valueOf()]: 'info.main',
        [InvoiceStatus.SCHEDULED.valueOf()]: 'warning.main',
        [InvoiceStatus.PROCESSING.valueOf()]: 'warning.main',
        [InvoiceStatus.SENT.valueOf()]: 'success.main',
        [InvoiceStatus.ERROR.valueOf()]: 'error.main',
        [InvoiceStatus.EXTERNAL_INVOICE_ERROR.valueOf()]: 'warning.main',
        [InvoiceStatus.VOIDED.valueOf()]: 'error.main',
    };

    return <Chip label={translate(status)} sx={{ minWidth: 80, color: '#fff', backgroundColor: colorMap[status] }} />;
};

export default InvoiceStatusChip;
